"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Applicants = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GroupMemberItem = require("./../../GroupMemberItem");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _DoNotDisturb = _interopRequireDefault(require("@insided/destination/icons/DoNotDisturb"));

var _SolvedQuestion = _interopRequireDefault(require("@insided/destination/icons/SolvedQuestion"));

var _Shield = _interopRequireDefault(require("@insided/destination/icons/Shield"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _service = require("./../../service");

var _classnames = _interopRequireDefault(require("classnames"));

var _Pagination = _interopRequireDefault(require("@insided/shared/uikit/Pagination"));

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_CURRENT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 25;

var GroupRequest = function GroupRequest(props) {
  return (0, _preact.h)("div", {
    className: "group-request"
  }, (0, _preact.h)("div", {
    className: "group-request__user"
  }, (0, _preact.h)(_GroupMemberItem.GroupMember, {
    member: props.user,
    disablePopup: true,
    isModeration: true
  })), (0, _preact.h)("div", {
    className: "group-request__actions"
  }, (0, _preact.h)(_Button.default, {
    size: "medium",
    className: "group-request__decline-btn",
    onClick: props.onDecline,
    disabled: props.isLoading,
    "data-bounded-context": "Groups",
    "data-entity": "group-applicants",
    "data-track-type": "click",
    "data-element-name": "Group Clicked reject join request"
  }, (0, _preact.h)(_DoNotDisturb.default, {
    height: 16,
    width: 16
  }), (0, _preact.h)(_phrase.default, {
    p: "groups.decline"
  })), (0, _preact.h)(_Button.default, {
    size: "medium",
    className: "group-request__approve-btn",
    onClick: props.onApprove,
    disabled: props.isLoading,
    "data-bounded-context": "Groups",
    "data-entity": "group-applicants",
    "data-track-type": "click",
    "data-element-name": "Group Clicked approve join request"
  }, (0, _preact.h)(_SolvedQuestion.default, {
    height: 16,
    width: 16,
    fill: "#24C25E"
  }), (0, _preact.h)(_phrase.default, {
    p: "groups.approve"
  }))));
};

var EmptyPage = function EmptyPage() {
  return (0, _preact.h)("div", {
    className: "group-moderation__applicants__empty"
  }, (0, _preact.h)(_Shield.default, {
    height: 40,
    width: 40,
    className: "group-moderation__applicants__empty__icon"
  }), (0, _preact.h)("div", {
    className: "group-moderation__applicants__empty__title"
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.all.good"
  })), (0, _preact.h)("div", {
    className: "group-moderation__applicants__empty__description"
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.all.good.description"
  })));
};

var Applicants = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Applicants, _Component);

  var _super = _createSuper(Applicants);

  function Applicants() {
    var _this;

    (0, _classCallCheck2.default)(this, Applicants);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "userId", (0, _insidedDataStorage.getInsidedData)('user').userid);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      applicantsLoading: false,
      applicants: [],
      applicantsTotal: null,
      currentPage: DEFAULT_CURRENT_PAGE,
      totalPagesCount: null,
      showMessage: false,
      messageStatus: 'success',
      messageText: null,
      applicantLoading: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchApplicants(DEFAULT_CURRENT_PAGE);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchApplicants", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(page) {
        var onApplicantsUpdate, _yield$fetchMembers, members, total;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                onApplicantsUpdate = _this.props.onApplicantsUpdate;

                _this.setState({
                  applicantsLoading: true
                });

                _context2.prev = 2;
                _context2.next = 5;
                return (0, _service.fetchMembers)({
                  groupId: _this.props.group.id,
                  page: page,
                  pageSize: DEFAULT_PAGE_SIZE,
                  filter: _service.fetchMembersFilters.Applicants
                });

              case 5:
                _yield$fetchMembers = _context2.sent;
                members = _yield$fetchMembers.members;
                total = _yield$fetchMembers.total;

                _this.setState({
                  applicantsLoading: false,
                  applicants: members,
                  applicantsTotal: total,
                  currentPage: page,
                  totalPagesCount: Math.ceil(total / DEFAULT_PAGE_SIZE)
                });

                onApplicantsUpdate(total);
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](2);

                _this.setState({
                  applicantsLoading: false,
                  applicants: [],
                  applicantsTotal: null,
                  currentPage: DEFAULT_CURRENT_PAGE,
                  totalPagesCount: null
                });

                onApplicantsUpdate(null);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 12]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNextPage", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.fetchApplicants(_this.state.currentPage + 1);

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPreviousPage", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this.fetchApplicants(_this.state.currentPage - 1);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDecline", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(userId) {
        var _this$state, currentPage, applicants, applicantsTotal, isNotFirstPage, isLastApplicantOnThePage, isLoadPreviousPage;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$state = _this.state, currentPage = _this$state.currentPage, applicants = _this$state.applicants, applicantsTotal = _this$state.applicantsTotal;

                _this.setState({
                  applicantLoading: userId
                });

                _context5.prev = 2;
                _context5.next = 5;
                return (0, _service.declineApplication)({
                  groupId: _this.props.group.id,
                  userId: userId
                });

              case 5:
                _this.setState({
                  showMessage: true,
                  messageStatus: 'success',
                  messageText: (0, _preact.h)(_phrase.default, {
                    p: "groups.applications.declined"
                  })
                });

                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](2);

                _this.setState({
                  showMessage: true,
                  messageStatus: 'error',
                  messageText: _context5.t0
                });

              case 11:
                _context5.prev = 11;

                _this.setState({
                  applicantLoading: null
                });

                isNotFirstPage = currentPage !== DEFAULT_CURRENT_PAGE;
                isLastApplicantOnThePage = applicants.length === 1;
                isLoadPreviousPage = isNotFirstPage && isLastApplicantOnThePage && applicantsTotal && applicantsTotal > 1;
                _context5.next = 18;
                return _this.fetchApplicants(isLoadPreviousPage ? currentPage - 1 : currentPage);

              case 18:
                return _context5.finish(11);

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 8, 11, 19]]);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onApprove", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(userId) {
        var _this$state2, currentPage, applicants, applicantsTotal, isNotFirstPage, isLastApplicantOnThePage, isLoadPreviousPage;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this$state2 = _this.state, currentPage = _this$state2.currentPage, applicants = _this$state2.applicants, applicantsTotal = _this$state2.applicantsTotal;

                _this.setState({
                  applicantLoading: userId
                });

                _context6.prev = 2;
                _context6.next = 5;
                return (0, _service.approveApplication)({
                  groupId: _this.props.group.id,
                  userId: userId
                });

              case 5:
                _this.setState({
                  showMessage: true,
                  messageStatus: 'success',
                  messageText: (0, _preact.h)(_phrase.default, {
                    p: "groups.applications.approved"
                  })
                });

                _publish.default.trackEvent('userevent', {
                  type: 'GroupMemberJoined',
                  payload: 'method3',
                  userId: userId,
                  addedBy: _this.userId
                });

                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](2);

                _this.setState({
                  showMessage: true,
                  messageStatus: 'error',
                  messageText: _context6.t0
                });

              case 12:
                _context6.prev = 12;

                _this.setState({
                  applicantLoading: null
                });

                isNotFirstPage = currentPage !== DEFAULT_CURRENT_PAGE;
                isLastApplicantOnThePage = applicants.length === 1;
                isLoadPreviousPage = isNotFirstPage && isLastApplicantOnThePage && applicantsTotal && applicantsTotal > 1;
                _context6.next = 19;
                return _this.fetchApplicants(isLoadPreviousPage ? currentPage - 1 : currentPage);

              case 19:
                return _context6.finish(12);

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 9, 12, 20]]);
      }));

      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(Applicants, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state3 = this.state,
          applicantsLoading = _this$state3.applicantsLoading,
          applicants = _this$state3.applicants,
          applicantsTotal = _this$state3.applicantsTotal,
          totalPagesCount = _this$state3.totalPagesCount,
          currentPage = _this$state3.currentPage,
          showMessage = _this$state3.showMessage,
          messageStatus = _this$state3.messageStatus,
          messageText = _this$state3.messageText,
          applicantLoading = _this$state3.applicantLoading;
      return (0, _preact.h)("div", {
        className: "group-moderation__applicants"
      }, !applicants.length && !applicantsLoading ? (0, _preact.h)(EmptyPage, null) : null, applicants.length ? (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "group-moderation__main__header"
      }, (0, _preact.h)("div", {
        className: "group-moderation__main__header__title"
      }, (0, _preact.h)("span", {
        className: "group-moderation__main__header__title__main"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.moderation.join.requests"
      })), (0, _preact.h)("span", null, "\u2022"), (0, _preact.h)("span", {
        className: "group-moderation__main__header__title__count"
      }, applicantsTotal, ' ', applicantsTotal && applicantsTotal > 1 ? (0, _preact.h)(_phrase.default, {
        p: "groups.applicants.info.requests"
      }) : null, applicantsTotal && applicantsTotal === 1 ? (0, _preact.h)(_phrase.default, {
        p: "groups.applicants.info.request"
      }) : null))), (0, _preact.h)("div", {
        className: "group-moderation__main__members"
      }, applicants.map(function (applicant) {
        return (0, _preact.h)(GroupRequest, {
          key: applicant.id,
          user: {
            id: applicant.id,
            name: applicant.username,
            userTitle: applicant.member_status,
            url: "/members/".concat(applicant.username.toLowerCase(), "-").concat(applicant.id),
            avatar: applicant.avatar
          },
          isLoading: applicantLoading === applicant.id,
          onApprove: function onApprove() {
            _this2.onApprove(applicant.id);
          },
          onDecline: function onDecline() {
            _this2.onDecline(applicant.id);
          }
        });
      })), (0, _preact.h)("div", {
        className: "group-moderation__main__footer"
      }, (0, _preact.h)("div", null, (0, _preact.h)(_Button.default, {
        size: "medium",
        onClick: this.onPreviousPage,
        className: (0, _classnames.default)('btn', 'btn--secondary', 'group-moderation__main__footer__previous', {
          hidden: currentPage === DEFAULT_CURRENT_PAGE
        })
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.previous"
      })), (0, _preact.h)("div", {
        className: "group-moderation__main__footer__pages"
      }, totalPagesCount && totalPagesCount > 1 ? (0, _preact.h)(_Pagination.default, {
        totalPageCount: totalPagesCount,
        currentPage: currentPage,
        generateNewUrl: function generateNewUrl() {
          return '';
        },
        onPageClick: /*#__PURE__*/function () {
          var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(e, i) {
            return _regenerator.default.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    e.preventDefault();
                    _context7.next = 3;
                    return _this2.fetchApplicants(i);

                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));

          return function (_x4, _x5) {
            return _ref7.apply(this, arguments);
          };
        }()
      }) : null), (0, _preact.h)(_Button.default, {
        size: "medium",
        onClick: this.onNextPage,
        className: (0, _classnames.default)('btn', 'btn--secondary', 'group-moderation__main__footer__next', {
          hidden: currentPage === totalPagesCount
        })
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.next"
      }))))) : null, showMessage ? (0, _preact.h)(_message.default, {
        variant: messageStatus,
        onDismiss: function onDismiss() {
          return _this2.setState({
            showMessage: false
          });
        },
        timer: 5000
      }, messageText) : null);
    }
  }]);
  return Applicants;
}(_preact.Component);

exports.Applicants = Applicants;
var _default = Applicants;
exports.default = _default;